import 'src/styles/base-settings.css';
import 'intersection-observer';
import '@ott/styles/css-vars-default.scss';
import 'src/styles/solarOverwrites.scss';

import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import { createStore } from 'src/redux/store';

import { getDefaultLocaleRedirectUrl } from 'src/helpers/locale';

import Root from './Root';

const localeRedirectUrl = getDefaultLocaleRedirectUrl(window.location);

if (localeRedirectUrl) {
  // replace, а не assign — чтобы «назад» не возвращал на недоступную локаль
  window.location.replace(localeRedirectUrl);
} else {
  const store = createStore(window.preloadedState);

  const container = document.getElementById('app')!;

  if (__DEV__ || __WHITE_LABEL__) {
    const root = ReactDOMClient.createRoot(container);

    root.render(<Root store={store} />);
  } else {
    ReactDOMClient.hydrateRoot(container, <Root store={store} />);
  }
}
